export enum CalendarDaysLoadDirection {
  FUTURE = 'FUTURE',
  PAST = 'PAST',
}
